import { Box, Button, HStack, Icon, Text } from "@chakra-ui/react";
import { HiArrowLeft } from "react-icons/hi";

type MobileBackButtonProps = {
  onBack: () => void;
  label: string;
};

export function MobileBackButton({ onBack, label }: MobileBackButtonProps) {
  return (
    <Box bg="gray.200" zIndex={10} borderBottom="1px" borderColor="gray.200">
      <HStack w="100%" p={4} py={2} align="center">
        <Button
          variant="ghost"
          onClick={onBack}
          leftIcon={<Icon as={HiArrowLeft} boxSize={5} />}
          size="sm"
          p={0}
          py={"2px"}
          minW="auto"
          h="auto"
          _hover={{ bg: "transparent" }}
        >
          <Text fontSize="md" fontWeight="medium" color="gray.600">
            {label}
          </Text>
        </Button>
      </HStack>
    </Box>
  );
}
